import { selectFromPlanningNotificationsResponse } from '../../models';

export default selectFromPlanningNotificationsResponse()
  .publishingSummary((ps) => ps
    .routesCount
    .ordersCount
    .driverNotifications((dn) => dn
      .unreachableDrivers)
    .customerNotifications((cn) => cn
      .deliveryMethod
      .unreachableCustomers))
  .toString();
